import FormComponent from "./form-component";
import Input, { FormParams } from "./input";

export default function EmailInput(params: FormParams) {
  return (
    <FormComponent
      id={params.id}
      label={params.label}
      className={params.className}
    >
      <Input type="email" autoComplete="email" {...params} />
    </FormComponent>
  );
}
